/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, FormEvent, useState} from 'react'
import {useAuth} from '../../../../app/modules/auth'
import {
  changePassword,
  getUserByToken,
  stopImpersonation,
} from '../../../../app/modules/auth/core/_requests'
import * as authHelper from '../../../../app/modules/auth/core/AuthHelpers'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout, saveAuth, setCurrentUser} = useAuth()
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false)
  const [password, setPassword] = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  const resetModal = () => {
    setPassword('')
    setPasswordConfirmation('')
    setError('')
    setSuccess('')
    setLoading(false)
  }

  const closeModal = () => {
    setShowChangePasswordModal(false)
    resetModal()
  }

  const submitPasswordChange = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setError('')
    setSuccess('')

    if (password.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres')
      return
    }

    if (password !== passwordConfirmation) {
      setError('As senhas devem coincidir')
      return
    }

    setLoading(true)
    try {
      await changePassword(password, passwordConfirmation)
      setSuccess('Senha alterada com sucesso')
      setPassword('')
      setPasswordConfirmation('')
      window.setTimeout(() => {
        closeModal()
      }, 1200)
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Erro ao alterar senha')
    } finally {
      setLoading(false)
    }
  }

  const handleStopImpersonation = async () => {
    const originalAuth = authHelper.getImpersonatorAuth()

    if (!originalAuth) {
      logout()
      return
    }

    try {
      await stopImpersonation()
    } catch (err) {
      console.error('Erro ao encerrar impersonificação:', err)
    } finally {
      saveAuth(originalAuth)
      authHelper.removeImpersonatorAuth()

      try {
        const {data} = await getUserByToken(originalAuth)
        setCurrentUser(data.data)
      } catch (err) {
        console.error('Erro ao restaurar usuário administrador:', err)
        logout()
        return
      }

      window.location.href = '/home'
    }
  }

  return (
    <>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-2 fs-6 w-250px'
        data-kt-menu='true'
      >
        {currentUser?.is_impersonating && (
          <>
            <div className='menu-item px-3 py-2'>
              <div className='px-5 text-gray-700'>
                <div className='fw-bold'>Sessão temporária</div>
                <div className='fs-8'>
                  Acessando como {currentUser.name}
                  {currentUser.impersonator?.name
                    ? ` por ${currentUser.impersonator.name}`
                    : ''}
                </div>
              </div>
            </div>
            <div className='menu-item px-3'>
              <a onClick={handleStopImpersonation} className='menu-link px-5 text-primary'>
                Voltar para minha conta
              </a>
            </div>
            <div className='separator my-2'></div>
          </>
        )}
        <div className='menu-item px-3'>
          <a
            onClick={() => setShowChangePasswordModal(true)}
            className='menu-link px-5'
          >
            Alterar senha
          </a>
        </div>
        <div className='menu-item px-3'>
          <a onClick={logout} className='menu-link px-5'>
            Sair
          </a>
        </div>
      </div>

      {showChangePasswordModal && (
        <>
          <div className='modal fade show d-block' tabIndex={-1} role='dialog'>
            <div className='modal-dialog modal-dialog-centered'>
              <div className='modal-content'>
                <form onSubmit={submitPasswordChange}>
                  <div className='modal-header'>
                    <h5 className='modal-title'>Alterar senha</h5>
                    <button
                      type='button'
                      className='btn-close'
                      aria-label='Close'
                      onClick={closeModal}
                    />
                  </div>

                  <div className='modal-body'>
                    <div className='mb-5'>
                      <label htmlFor='profile-new-password' className='form-label'>
                        Nova senha
                      </label>
                      <input
                        id='profile-new-password'
                        type='password'
                        className='form-control'
                        autoComplete='new-password'
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                      />
                    </div>

                    <div className='mb-5'>
                      <label htmlFor='profile-password-confirmation' className='form-label'>
                        Confirmar senha
                      </label>
                      <input
                        id='profile-password-confirmation'
                        type='password'
                        className='form-control'
                        autoComplete='new-password'
                        value={passwordConfirmation}
                        onChange={(event) => setPasswordConfirmation(event.target.value)}
                      />
                    </div>

                    {error && <div className='alert alert-danger mb-0'>{error}</div>}
                    {success && <div className='alert alert-success mb-0'>{success}</div>}
                  </div>

                  <div className='modal-footer'>
                    <button type='button' className='btn btn-light' onClick={closeModal}>
                      Cancelar
                    </button>
                    <button
                      type='submit'
                      className='btn btn-primary'
                      disabled={loading || !password || !passwordConfirmation}
                    >
                      {loading ? 'Salvando...' : 'Salvar'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className='modal-backdrop fade show' />
        </>
      )}
    </>
  )
}

export {HeaderUserMenu}
